// extracted by mini-css-extract-plugin
export default {"rateTable":"XjzediInZxAgiclt6pSh","rateTableIframe":"r2FnzI_n0_0KvvqSqxoX"};